import { ReactNode } from 'react'

interface TabIconLabelProps {
  icon: ReactNode
  label: string
}

/**
 * TabIconLabel Component
 *
 * Standardized tab label with icon and text.
 * Used in Ant Design Tabs to maintain consistent styling.
 *
 * @example
 * <Tabs items={[
 *   {
 *     key: "settings",
 *     label: <TabIconLabel icon={<HiOutlineCog />} label="Settings" />,
 *     children: <SettingsContent />
 *   }
 * ]} />
 */
export const TabIconLabel = ({ icon, label }: TabIconLabelProps) => (
  <span className="flex items-center gap-2">
    {icon}
    {label}
  </span>
)
